
import{ isMobile, innerW, bp }from"./utils/variables";
import{ ifModuleThenImport, runDefaultAt }from"./import-functions";

export default function runLoader(){
    initGlobalScripts();
    initModuleScripts();
}

function initGlobalScripts(){
    if(!isMobile || innerW < bp.tbl){
        runDefaultAt("./helpers/link-prefetch");

    }else{
        const scrollToEls = document.querySelectorAll<HTMLElement>("[data-scroll-to]");

        scrollToEls.forEach(el => {
            el.addEventListener("click", (e) => {
                e.preventDefault();

                const attr = el.getAttribute("data-scroll-to");
                if(!attr)return;

                const target = document.querySelector(attr);
                if(target) target.scrollIntoView({ behavior: "smooth" });
            });
        });
    }

    runDefaultAt("./utils/variables");
    runDefaultAt("./base/novotel");
    runDefaultAt("./base/qr-main");
}

// ifModuleThenImport(el, module file name, scrolltrigger?) - pass in element, if that element exists on the page
// and if so import the module file when the script is needed
// third param is a bool- true means the file will only be imported when the user scrolls to that block
function initModuleScripts(){
    ifModuleThenImport(".text-slider", "text-slider", false);
    ifModuleThenImport(".lottie-el", "lottie", false);
}